import { jsx as _jsx } from "react/jsx-runtime";
import useGetResellerCustomers from "src/features/resellerCustomers/hooks/useGetResellerCustomers";
import ResellerCustomersContainer from "src/features/resellerCustomers/ResellerCustomersContainer";
const ResellerCustomersContainerWrapper = () => {
    const { isLoading } = useGetResellerCustomers();
    return _jsx(ResellerCustomersContainer, { isLoading: isLoading });
};
export default ResellerCustomersContainerWrapper;
